<template>
  <span class="refreshCodeBtn">
    <b-button variant="white" class="text-primary" title="重新取得驗證碼" @click="refreshCode">
      <i class="fas fa-undo"></i>
      <span class="sr-only">重新取得驗證碼</span>
    </b-button>
  </span>
</template>
<script>
export default {
  name: 'RefreshCodeBtn',

  // props: {
  //   btnSize: {
  //     type: String,
  //     default: '',
  //   },
  //   btnClass: {
  //     type: String,
  //     default: '',
  //   },
  //   btnVariant: {
  //     type: String,
  //     default: '',
  //   },
  //   btnName: {
  //     type: String,
  //     default: '',
  //   },
  // },

  data() {
    return {
      identifyCode: '',
      identifyCodes: '234567890abcdefghkmnopqrstuvwxyzABCDEFGHKMNOPQRSTUVWXYZ',
    };
  },

  methods: {
    // 產生 驗證碼
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      console.log(o, l);
      for (let i = 0; i < l; i += 1) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      console.log(this.identifyCode);
    },
  },
};
</script>
